import React, { useState, useRef } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { searchBeers, fetchBeers } from "../actions/beerActions";

const Search = ({ searchBeers, fetchBeers }) => {
  const [keyword, setKeyword] = useState("");
  const timeout = useRef(null);

  const onSearch = e => {
    // get input string from event obj
    const value = e.target.value;
    setKeyword(value);

    if (timeout.current) clearTimeout(timeout.current); // if timeout is not null, clear
    timeout.current = setTimeout(() => handleSearch(value), 500); // wait for user to stop typing then trigger search
  };

  const handleSearch = keyword => {
    // if input is not empty, trigger search
    if (keyword.trim().length !== 0) {
      searchBeers(keyword);
    } else {
      // if an empty string is searched, reload beer list
      fetchBeers();
    }
  };

  return (
    <div className="row justify-content-center">
      <form className="col-md-6 col-sm-12" onSubmit={e => e.preventDefault()}>
        <div className="form-group">
          <input
            type="text"
            className="form-control"
            placeholder="Search for beer name"
            value={keyword}
            onChange={onSearch}
          />
        </div>
      </form>
    </div>
  );
};

// redux stuff
Search.propTypes = {
  searchBeers: PropTypes.func.isRequired,
  fetchBeers: PropTypes.func.isRequired
};

export default connect(
  null,
  { searchBeers, fetchBeers }
)(Search);
